import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons';

const imageCarousel = (): void => {
  const selectors = {
    imageCarousel: '[data-image-carousel]',
    imageCarouselViewport: '[data-image-carousel-viewport]',
    imageCarouselPrev: '[data-image-carousel-prev]',
    imageCarouselNext: '[data-image-carousel-next]',
  };

  const imageCarousels = document.querySelectorAll(selectors.imageCarousel);

  if (imageCarousels) {
    imageCarousels.forEach((carousel) => {
      const viewportNode: HTMLDivElement = carousel.querySelector(
        selectors.imageCarouselViewport
      );
      const prevBtnNode: HTMLElement = carousel.querySelector(
        selectors.imageCarouselPrev
      );
      const nextBtnNode: HTMLElement = carousel.querySelector(
        selectors.imageCarouselNext
      );

      const options: EmblaOptionsType = {
        loop: true,
        align: 'start',
      };

      const embla = EmblaCarousel(viewportNode, options);

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        embla,
        prevBtnNode,
        nextBtnNode
      );
    });
  }
};

export default imageCarousel;
